import { render, staticRenderFns } from "./MemberListJudgeLayout.vue?vue&type=template&id=3e12d183&scoped=true&"
import script from "./MemberListJudgeLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListJudgeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12d183",
  null
  
)

export default component.exports